import { render, staticRenderFns } from "./CheckboxItemImage.vue?vue&type=template&id=26068c6a&scoped=true"
import script from "./CheckboxItemImage.vue?vue&type=script&lang=js"
export * from "./CheckboxItemImage.vue?vue&type=script&lang=js"
import style0 from "./CheckboxItemImage.vue?vue&type=style&index=0&id=26068c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26068c6a",
  null
  
)

export default component.exports